/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        keycloakId: json['keycloakId'],
        firstName: json['firstName'],
        lastName: json['lastName'],
        email: json['email'],
        avatar: json['avatar'],
        isSuperUser: !exists(json, 'isSuperUser') ? undefined : json['isSuperUser'],
    };
}
export function UserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        keycloakId: value.keycloakId,
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        avatar: value.avatar,
        isSuperUser: value.isSuperUser,
    };
}
